import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { isCosmosEnabled, getCollections } from "../api/cosmos-api";

const useCosmosCollections = () => {
  const [collections, setCollections] = useState([]);

  const { isLoading: clientExistsLoading, data: clientExists } = useQuery(
    ["cosmos-client-exists"],
    isCosmosEnabled,
    {
      retry: 0,
      select: (response) => {
        const { data } = response;
        return data;
      },
    }
  );

  const { isLoading: collectionsLoading, data: collectionsData } = useQuery(
    ["cosmos-collections"],
    getCollections,
    {
      enabled: !clientExistsLoading && clientExists,
      retry: 0,
      select: (response) => {
        const { data } = response;
        const formatted = data
          .map((collection) => ({
            label: collection.name,
            value: collection.id,
            data: collection,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        return formatted;
      },
    }
  );

  useEffect(() => {
    if (!collectionsLoading && collectionsData) {
      setCollections([...collectionsData]);
    }
  }, [collectionsData, collectionsLoading]);

  return {
    isLoading: collectionsLoading,
    collections,
  };
};

export default useCosmosCollections;
